import { useMemo } from 'react';
import { useOpgavekompleksetComponent } from './context.data.js';
import { useOpgavekompleksetEntry } from './hook.entry.js';

function useCurrentTask() {
  const component = useOpgavekompleksetComponent();
  const entry = useOpgavekompleksetEntry();
  const activeTaskIndex = useMemo(() => {
    const index = component.data.tasks.findIndex(it => it.id === entry?.data.activeTaskId);
    if (index === -1) {
      return 0;
    } else {
      return index;
    }
  }, [component.data.tasks, entry?.data.activeTaskId]);
  return {
    task: component.data.tasks[activeTaskIndex],
    index: activeTaskIndex
  };
}

export { useCurrentTask };
//# sourceMappingURL=hook.current-task.js.map
